import React from 'react'
import PrintView from '../../components/PrintView/PrintView'
import image from '../../assets/images/roar-product.jpg'

const ImHome = () => {
  return <PrintView
  title='Tell the wild. I’m home'
  heading='Tell the wild. I’m home'
  content='“ As beautiful as it looks this was a very hard angle to capture a leopard in. I was able to capture this at the Wilpaththu National Park. This is also a detailed high resolution image of a well grown male in his habitat.'
  printImage={image}
 />
}

export default ImHome